import Vue from 'vue';
import contentApiService from '@/core/http/contentApi.service';
import serverContextService from '@/core/serverContext.service';
import { WebsiteNotificationViewModel } from '@/types/contentServerContract';
import loggingService from '@/core/logging.service';
import { LOGGED_IN, LOGGED_OFF } from '@/core/auth/auth.service';
import bus from '@/core/bus';

interface INotifcationsState {
    notification: WebsiteNotificationViewModel | null;
    visible: boolean;
}

// const pollingInterval = 60 * 5 * 1000; // 5 minutes in milliseconds

class NotificationsService {
    private state: INotifcationsState = Vue.observable({
        notification: null,
        visible: true
    });

    constructor() {
        // Delay initial load of notifications
        setTimeout(() => this.getNotifications(), 1500);

        bus.on(LOGGED_IN, () => {
            this.showNotification();
            this.getNotifications();
        });

        bus.on(LOGGED_OFF, () => {
            this.showNotification();
            this.getNotifications();
        });
    }

    private async getNotifications() {
        const url = serverContextService.settings?.notificationsLink;
        if (!url) {
            loggingService.warn('Tried to fetch website notifications but notificationsLink not present in server context!');
            return;
        }

        try {
            const result = await contentApiService.getContent<WebsiteNotificationViewModel>(url);
            if (result.message) {
                // Notification changed - show it
                if (result.message !== this.state.notification?.message) {
                    this.showNotification();
                }

                this.state.notification = result;
            }
        } catch (e) {
            // No content - ignored
        }
    }

    public get notification(): WebsiteNotificationViewModel | null {
        return this.state.visible ? this.state.notification : null;
    }

    public hideNotification() {
        this.state.visible = false;
    }

    public showNotification() {
        this.state.visible = true;
    }
}

export default new NotificationsService();
